// Formatting a stock quantity with its unit of measurement.
//
// Inventory units are a mix of two kinds, and they read differently:
//   symbols — g, kg, ml, l, oz  ->  "0.2kg"   (space looks wrong)
//   words   — pieces, bottles   ->  "10 pieces" (no space looks broken)
//
// Shared because the web glance widget (components/portal/EodGlanceWidget) and
// the native one (portal-app/tabs/HomeEodGlance) must render stock identically;
// two inline copies of this rule would drift the first time someone fixed only
// the surface they were looking at.

// Unit symbols are short — the longest in real use is 3 characters ("gal").
// Anything longer is a word and takes a space.
const SYMBOL_MAX_LENGTH = 3;

export const formatQuantity = (quantity, unit) => {
    const amount = quantity == null ? '' : String(quantity);
    const u = (unit || '').trim();
    if (!u) return amount;
    return u.length <= SYMBOL_MAX_LENGTH ? `${amount}${u}` : `${amount} ${u}`;
};

export default formatQuantity;
